module.exports = __webpack_public_path__ + "img/lantu.93363c5b.png";